import Toast from '@/components/Elements/toast/toast.js'
import { determinedSimpleProduct } from '../helpers/basket-items'
import resetStore from '../helpers/reset-store'
import axios from 'axios';

export const state = () => ({
  products: [],
  items: []
})

export const mutations = {
  reset: resetStore(state),
  add(state, id) {
    state.products.push(+id)
  },
  setItems(state, items) {
    state.items = items
  },
  init(state, products) {
    state.products = products
  },
  remove(state, id) {
    state.products = state.products.filter(o => o !== id)
    state.items = state.items.filter(o => +o.internalId !== id)
  }
}

export const getters = {
  products(state) {
    return state.products
  },
  items(state) {
    return state.items
  }
}

export const actions = {
  async add({ commit }, id) {
    try {
      await axios.post('/api/wish-list', {
        product_id: id
      })
      Toast.show({
        text: `Added to wish list successfully`,
        color: 'ready',
        timeout: 3000,
        x: 'right',
        dismissable: true,
        icon: 'ready'
      })
      commit('add', id)
    } catch (e) {
      console.log(e)
      Toast.show({
        text: 'Error occurred',
        color: 'error',
        timeout: 3000,
        x: 'right',
        dismissable: true,
        icon: 'error'
      })
    }
  },
  async remove({ commit }, id) {
    try {
      await axios.delete(`/api/wish-list/${id}`)
      Toast.show({
        text: `Removed from wish list successfully`,
        color: 'ready',
        timeout: 3000,
        x: 'right',
        dismissable: true,
        icon: 'ready'
      })
      commit('remove', id)
    } catch (e) {
      console.log(e)
      Toast.show({
        text: 'Error occurred',
        color: 'error',
        timeout: 3000,
        x: 'right',
        dismissable: true,
        icon: 'error'
      })
    }
  },
  async fetchItems({ state, commit }) {
    const { data } = await axios.$get('/api/item', {
      params: {
        'internalId[$in]': state.products.length ? state.products : [0],
        includeFinished: true,
        includeChildren: true,
        includePricing: true
      }
    })
    commit('setItems', data)
  },
  async addItemsToBasket({ dispatch }, { data }) {
    if (Array.isArray(data)) {
      data.map(item => {
        dispatch('addItemToBasket', {
          product: item
        })
      })
    }
  },

  async addItemToBasket({ dispatch }, { product }) {
    if (product.internalId) {
      if (
        product.matrixType === '_parent' ||
        product.custitem_bbs_item_finish_ref
      ) {
        // Determined the product simple by attribute option that user selected
        const simple = determinedSimpleProduct(product)
        dispatch(
          'basket/addToBasket',
          {
            removeId: product.internalId,
            parentId: product.internalId,
            productId: simple ? simple.internalId : product.internalId,
            qty: product.qty,
            isAdd: true
          },
          { root: true }
        )
      }
    }
  },
  setInitialData({ commit }, data) {
    commit('init', data)
  }
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
